import dayjs from 'dayjs';

import { DataModel } from '../../dto/data-model.js';
import { BusinessModuleRef } from '../business-module-ref.js';

export enum QrObjectType {
  GenericProduct = 'GenericProduct',
}

export abstract class QrObjectReference extends DataModel {
  abstract get uniqueId(): string;
  abstract get scanCode(): string;
  abstract get creationDate(): dayjs.Dayjs;
  abstract get businessRef(): BusinessModuleRef;
  abstract get eventId(): string;
  abstract get orderId(): string;
  abstract get type(): QrObjectType;
}
